import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_DISCOUNT_SAGA } from "../sagaTypes";
import { loaderAction, discountFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionDataSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/update_discount`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateDiscount(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('name', args.data.name);
        formData.append('percent', args.data.percent);
        formData.append('establishments', args.data.establishments);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            yield put(typeOpenSettingsFormAction(''));
            // Сбрасываем данные в форме скидки
            yield put(discountFormAction({
                id: '',
                name: '',
                percent: '',
                establishments: []
            }));
            // Получаем обновлённый список скидок
            yield put(getSubscriptionDataSagaAction());
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateDiscount() {
    yield takeLatest(UPDATE_DISCOUNT_SAGA, workerUpdateDiscount);
}